import { drizzle, type SqliteRemoteDatabase } from 'drizzle-orm/sqlite-proxy';
import type { SqlDriver } from './driver';

export type LocalDb = SqliteRemoteDatabase;

/** Drizzle's sqlite-proxy driver over our SqlDriver. db.batch() runs in one transaction in the driver. */
export function createLocalDb(driver: SqlDriver): LocalDb {
  return drizzle(
    async (sql, params, method) => (await driver.query({ sql, params, method })) as { rows: any[] },
    async (queries) =>
      (await driver.batch(
        queries.map((q) => ({ sql: q.sql, params: q.params, method: q.method })),
      )) as { rows: any[] }[],
  );
}
